import { Button, Checkbox, IconButton, Tooltip } from "@mui/material";
import { useTipos } from "../../../../context/SuperAdmin/OASContexts/TiposContext";
import { iDataTipo } from "../../../../interfaces/SuperAdmin/Pages/iDataTipos";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../ui-components/StyledTables";
import { formatFechaWithHour } from "../../../../utils/dateFunctions";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

interface Props {
  tipo: iDataTipo;
  i: number;
  isSelected: boolean;
  handleSelect: (id: string) => void;
}

export const TiposRow: React.FC<Props> = ({
  tipo,
  i,
  isSelected,
  handleSelect,
}) => {
  const { nombre, created_at } = tipo;
  const { handleEditTipo } = useTipos();

  return (
    <StyledTableRow>
      <StyledTableCell>
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={() => handleSelect(tipo.id_tipo)}
        />
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center", maxWidth: 400 }}>
        {nombre}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {formatFechaWithHour(created_at)}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        <Button sx={{ color: "#336B87" }} onClick={() => handleEditTipo(tipo)}>
          <Tooltip title="Editar tipo">
            <IconButton aria-label="edit" sx={{ color: "#336B87" }}>
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>
      </StyledTableCell>
    </StyledTableRow>
  );
};
